import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import {
  GetReasonRequest,
  GetReasonsRequest,
  UpdateReasonRequest,
} from "api/types/requests";
import QueryTags from "api/types/QueryTags";
import PaginatedResponse from "api/types/PaginatedResponse";
import LocationReason from "api/types/models/location_reason";

const reasonEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getReason: builder.query<LocationReason, GetReasonRequest>({
    query: ({ reasonUuid }) => ({
      url: `/reasons/${reasonUuid}`,
    }),
    providesTags: ["Reason"],
  }),

  getReasons: builder.query<
    PaginatedResponse<LocationReason[]>,
    GetReasonsRequest
  >({
    query: ({ locationUuid, includeDisabled, search, page, size }) => ({
      url: "/reasons",
      params: {
        include_disabled: includeDisabled,
        ...(locationUuid && { location_uuid: locationUuid }),
        ...(search && { search: search }),
        ...(page && { page }),
        ...(size && { size }),
      },
    }),
    providesTags: ["Reasons", "Practitioners", "Practitioner"],
  }),

  updateReason: builder.mutation<
    LocationReason,
    { id: string; body: UpdateReasonRequest }
  >({
    query: ({ id, body }) => ({
      url: `/reasons/${id}`,
      method: "put",
      body,
    }),
    invalidatesTags: ["Reasons", "Reason"],
  }),
});

export default reasonEndpoints;
